// src/components/ui/otp-input.jsx
import React, { useState, useRef, useEffect } from 'react';

const OTPInput = ({ length = 6, onComplete, disabled = false }) => {
  const [otp, setOtp] = useState(new Array(length).fill(''));
  const inputs = useRef([]);

  // Helper to move focus to next/previous input
  const focusInput = (index) => {
    if (inputs.current[index]) {
      inputs.current[index].focus();
    }
  };

  // Handle individual input change
  const handleChange = (e, index) => {
    const value = e.target.value;
    const newOtp = [...otp];
    
    // Only take the last character if multiple characters are entered
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);

    // Move to next input if value is entered
    if (value && index < length - 1) {
      focusInput(index + 1);
    }

    // Call onComplete if all fields are filled
    if (!newOtp.includes('')) {
      onComplete(newOtp.join(''));
    }
  };

  // Handle backspace and arrow keys
  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace') {
      if (!otp[index] && index > 0) {
        // If current input is empty, move to previous input and clear it
        const newOtp = [...otp];
        newOtp[index - 1] = '';
        setOtp(newOtp);
        focusInput(index - 1);
      }
    } else if (e.key === 'ArrowLeft' && index > 0) {
      focusInput(index - 1);
    } else if (e.key === 'ArrowRight' && index < length - 1) {
      focusInput(index + 1);
    }
  };

  // Handle paste
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text/plain').slice(0, length);
    
    if (pastedData.match(/^\d+$/)) {
      const newOtp = [...otp];
      pastedData.split('').forEach((char, index) => {
        if (index < length) {
          newOtp[index] = char;
        }
      });
      setOtp(newOtp);
      
      if (newOtp.length === length && !newOtp.includes('')) {
        onComplete(newOtp.join(''));
      }
    }
  };

  // Focus first input on mount
  useEffect(() => {
    if (!disabled) {
      focusInput(0);
    }
  }, [disabled]);

  return (
    <div className="flex gap-2 justify-center">
      {otp.map((digit, index) => (
        <input
          key={index}
          ref={(el) => inputs.current[index] = el}
          type="text"
          inputMode="numeric"
          pattern="\d*"
          maxLength={1}
          value={digit}
          disabled={disabled}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onPaste={handlePaste}
          className={`
            w-12 h-14 text-2xl text-center font-semibold
            border-2 rounded-lg
            focus:border-[#7ABB23] focus:ring-2 focus:ring-[#7ABB23] focus:outline-none
            disabled:bg-gray-100 disabled:text-gray-400
            transition-colors
            ${!digit ? 'border-gray-300' : 'border-[#7ABB23]'}
          `}
        />
      ))}
    </div>
  );
};

export default OTPInput;